import { Component, OnInit } from '@angular/core';
import { CompanyService, Company } from "app/services/company.service";
import { BaseComponent } from "app/components/base.component";
import { PaginationService } from "app/services/pagination.service";
import { NotificationsService } from "angular2-notifications";
import * as _ from 'underscore';

@Component({
	selector: 'app-companies',
	templateUrl: './companies.component.html',
	styleUrls: ['./companies.component.less']
})
export class CompaniesComponent extends BaseComponent implements OnInit {
	

	companies: Company[];
	private allItems: Company[];
	private allItemsOri: Company[];
	pager: any = {};
	pagedItems: any[];

	q: string = '';
	ck: string = '';

	constructor(
		private companyService: CompanyService,
		private paginationService: PaginationService,
		private notificationsService: NotificationsService
	) {
		super();
	}

	ngOnInit() {
		this.companyService.getCompanies().subscribe(companies => {
			this.companies = companies.sort((a, b) => {
				a.name = a.name || '';
				b.name = b.name || '';
				if (a.name == b.name) {
					return 0;
				}
				return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
			})
			this.allItemsOri = _.clone(this.companies);
			this.allItems = _.clone(this.companies);
			this.setPage(1);
		})
	}

	onDeleteClick(id) {
		var self = this;
		if (id) {
			if (confirm('Are you sure?')) {
				this.companyService.deleteCompany(id).then(function () {
					self.notificationsService.error('Deleted', '1 company deleted')
				}).catch(function (e) {
					console.log('There is an error. ' + e.message);
				});;
			}
		} else {
			return false;
		}
	}

	setPage(page: number) {
		// get pager object from service
		this.pager = this.paginationService.getPager(this.allItems.length, page);

		// get current page of items
		this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
	}

	filter_result() {
		if (this.q || this.ck) {
			this.allItems = this.allItemsOri.filter(item => {
				var regex = new RegExp(this.escapeRegExp(this.q), 'gi');
				var regex2 = new RegExp(this.escapeRegExp(this.ck), 'gi');

				var name = regex.test(item.name);
				// var cat  = this.cat_id ? item.category_id == this.cat_id : true;
				var country = regex2.test(item.country_key);

				return name && country;
			})
		}
		else {
			this.allItems = this.allItemsOri;
		}

		this.setPage(1);
	}

	escapeRegExp(str) {
		return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/company/companies/companies.component.ts